export const MAIN_NAVIGATION_COLLECTION = 'mainNavigation';
export const ACTION_BUTTONS_COLLECTION = 'actionButtons';

export const MAX_AMOUNT_OF_BUTTONS = 2;
